import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "@/routes/rootRoute";

export const documentationRoute = createRoute({
  path: "/documentation",
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(async () => {
    const m = await import("./Documentation");
    return { default: m.Documentation };
  }),
});
